import CommonHeader from "../../../components/ui/CommonHeader";
import ContentText from "../../../components/ui/ContentText";
import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";

export default function RefundPolicy() {
  return (
    <WebLayout>
      <CommonHeader
        title="রিফান্ড নীতিমালা"
        description="সর্বশেষ আপডেট: জানুয়ারি ০৮, ২০২৬"
        hideIcon
      />

      <div className="mini-container !max-w-[800px] pt-28">
        <ContentText title="রিফান্ড নীতিমালা" classNames={{ root: "mb-8" }}>
          আপনি যদি কোনো কোর্সে এনরোল করেন কিংবা ভর্তি হোন, তাহলে আপনার কোর্স
          শুরু হওয়ার আগ পর্যন্ত আপনি কোর্স ফি (সম্পুর্ন কিংবা আংশিক) কোনো মতেই
          রিফান্ড চাইতে পারবেন না এবং আপনাকে রিফান্ড করা হবে না।
          <ul className="mt-4 space-y-4 list-inside list-disc">
            <li>
              আপনার যদি কোর্স শুরু হয়ে যায়, তবে প্রথম মডিউল (কিংবা এক (১)
              সপ্তাহ) কমপ্লিট হওয়া পর্যন্ত আপনি কোনো রিফান্ড পাবেন না।
            </li>
            <li>
              আপনার কোর্সের ১ টি মডিউল অথবা এক (১) সপ্তাহ হওয়ার পর শর্ত
              স্বাপেক্ষে আপনি রিফান্ড পাবেন।
            </li>
            <li>
              এই রিফান্ড দাবি করার জন্য আপনি শুধুমাত্র ১ সপ্তাহ (৭ দিন) সময়
              পাবেন। এক সপ্তাহ (৭ দিন) শেষ হয়ে গেলে আর রিফান্ডের জন্য আবেদন
              করতে পারবেন না কিংবা ManPowerX আপনাকে রিফান্ড করবে না।
            </li>
            <li>
              আপনি যদি প্রোমোকোড এপ্লাই না করে এনরোল করেন তাহলে প্রোমোকোড
              ডিসকাউন্ট সম্পরিমান টাকা রিফান্ড চাইতে পারবেন না।
            </li>
          </ul>
        </ContentText>

        <ContentText
          title="রিফান্ড পাওয়ার শর্তসমুহ"
          classNames={{ root: "mb-8" }}
        >
          ওপরের শর্তসমুহসহ রিফান্ড পাওয়ার জন্য আরো শর্তাবলী:
          <ul className="mt-4 space-y-4 list-inside list-disc">
            <li>
              অবশ্যই আপনার কোর্সটি যদি সম্পুর্ন পেমেন্ট করা থাকে তবেই আপনি
              রিফান্ডের আবেদন করতে পারবেন।
            </li>
            <li>রিফান্ড পাওয়ার জন্য অবশ্যই যথাযথ কারন প্রদর্শন করতে হবে।</li>
            <li>
              শুধুমাত্র সার্ভিসজনিত কারনে যদি কোর্সে পেমেন্টকারী কোনো অসুবিধার
              সম্মুখীন হয়, তবেই শুধুমাত্র রিফান্ডের আবেদন করা যাবে।
            </li>
            <li>
              এই রিফান্ড দাবি করার জন্য আপনি শুধুমাত্র ১ সপ্তাহ (৭ দিন) সময়
              পাবেন। এক সপ্তাহ (৭ দিন) শেষ হয়ে গেলে আর রিফান্ডের জন্য আবেদন
              করতে পারবেন না কিংবা ManPowerX আপনাকে রিফান্ড করবে না।
            </li>
          </ul>
        </ContentText>

        <ContentText
          title="রিফান্ড আবেদনের কতদিনের মধ্যে পাবেন?"
          classNames={{ root: "mb-8" }}
        >
          আপনার আবেদন যাচাই বাছাই শেষে যদি সঠিক প্রতিয়মান হয় তবে আবেদনের ১৪-২১
          দিনের মধ্যে আপনার টাকা রিফান্ড করে দেয়া হবে।
        </ContentText>

        <ContentText title="যোগাযোগ">
          রিফান্ড চাওয়ার বা আবেদনের জন্য আমাদেরকে মেইল করুন:
          <div className="p-6 bg-theme-slate-50 rounded-[10px] mt-4">
            <div>
              ইমেইল:{" "}
              <a className="font-roboto" href="mailto:manpowerx.org@gmail.com">
                manpowerx.org@gmail.com
              </a>
            </div>
            <div>
              ফোন: <a href="tel:+8801611090323">০১৬১১-০৯০৩২৩</a>
            </div>
            <div>
              ঠিকানা: হাউস-২৫, রোড-৫, ব্লক-জে, বনশ্রী, রামপুরা, ঢাকা-১২১৯
            </div>
          </div>
        </ContentText>
      </div>

      <Platform />
      <Footer isPlatform />
    </WebLayout>
  );
}
